import { Helmet } from "react-helmet-async";
import { useApi } from "@/lib/api";

export const GoogleVerify = () => {
  const { data: s } = useApi("/settings");
  const code = (s?.google_verification || "").replace(/.*content="([^"]+)".*/s, "$1").trim();
  if (!code) return null;
  return <Helmet><meta name="google-site-verification" content={code} /></Helmet>;
};
